/** @jsx jsx */
import { css } from '@emotion/react';
import { borderRadius } from '@atlaskit/theme/constants';
import { N0, N50A, N60A } from '@atlaskit/theme/colors';
export var pickerStyle = css({
  verticalAlign: 'middle',
  '&.miniMode': {
    display: 'inline-block'
  }
});
export var contentStyle = css({
  display: 'flex'
});
export var popupWrapperStyle = css({
  ':focus': {
    outline: 'none'
  }
});
export var popupStyle = css({
  background: "var(--ds-surface-overlay, ".concat(N0, ")"),
  borderRadius: "".concat(borderRadius(), "px"),
  boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat(N50A, ", 0 0 1px ").concat(N60A), ")"),
  '&> div': {
    boxShadow: undefined,
    marginTop: '4px',
    marginBottom: '4px'
  }
});